import { jsx as _jsx } from "react/jsx-runtime";
import { Box, useMultiStyleConfig } from "@chakra-ui/react";
const SearchPanelFooter = ({ children }) => {
    const styles = useMultiStyleConfig("SearchPanel");
    return _jsx(Box, Object.assign({ sx: styles.footer }, { children: children }));
};
export default SearchPanelFooter;
//# sourceMappingURL=SearchPanelFooter.js.map